module.exports = __webpack_public_path__ + "img/2.0223b703.png";